import isFunction from 'lodash/isFunction';
import isObject from 'lodash/isObject';

export default  {
  isEnabled: function () {
    return !!isObject(window.embeddedCheckout);
  },
  collapseFullScreen: function () {
    if (this.isEnabled() && isFunction(window.embeddedCheckout.collapseFullScreen())) {
      window.embeddedCheckout.collapseFullScreen();
    }
  },
  expandFullScreen: function () {
    if (this.isEnabled() && isFunction(window.embeddedCheckout.expandFullScreen())) {
      window.embeddedCheckout.expandFullScreen();
    }
  }
};



// WEBPACK FOOTER //
// ./frontend/react/utils/embeddedCheckout/index.js